import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'
import {createSlice} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";
import {rootReducer} from "../store";

export const tnvedApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'tnvedApi',
  endpoints: (builder) => ({
    getTnved: builder.query<TnvedInfo, string>({
      query: (query) => `dictionary/alta/tnved/${query}/`,
    }),
  }),
})

export const { useLazyGetTnvedQuery } = tnvedApi

export const tnvedCodesSlice = createSlice({
  name: 'tnvedCodes',
  initialState: {
    codes: [] as TnvedInfoMap[],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      tnvedApi.endpoints.getTnved.matchFulfilled,
      (state, { payload }) => {
        state.codes = [
          ...state.codes,
          { [payload?.GoodInfo?.Code]: payload }
        ];
      }
    )
  },
})

export const useTnvedCodes = () => {
  return useSelector(({ tnvedCodes }: ReturnType<typeof rootReducer>) => tnvedCodes.codes)
}
